import React from 'react';

export const CustomToolTip = ({ point, legend, legendData, x, y, xFormat, yFormat, useIndex }) => {
    const isTop = point.point?.y < 50;
    const colour = point.point ? point.point.serieColor : point.color;
    let xValue = useIndex ? point.indexValue : point.point ? point.point.data.xFormatted : point.data[x || 'xFormatted'];
    let yValue = useIndex ? point.data[point.id] : point.point ? point.point.data.yFormatted : point.data[y || 'yFormatted'];
    //xValue = isNaN(xValue) ? xValue : xValue.toLocaleString();
    //yValue = isNaN(yValue) ? yValue : yValue.toLocaleString();

    let legendLabel = useIndex ? { label: point.id } : legendData?.find(d => d.id === point?.point?.serieId);

    if (!yFormat) {
        yFormat = x => {
            if (useIndex) return yValue.toString().indexOf('.') ? Math.round(yValue * 10) / 10 : yValue;
            return x.toString().indexOf('.') ? Math.round(x * 10) / 10 : x;
        };
    }

    const holder = React.useRef(null);

    React.useEffect(() => {
        if (holder.current) {
            const holderWidth = holder.current.parentElement.parentElement.parentElement.clientWidth;
            const width = holder.current.parentElement.parentElement.clientWidth;
            const translate = holder.current.parentElement.parentElement.style.transform;
            const pos = parseInt(translate.substring(10, translate.indexOf('px,')), 10);
            if (pos + width * 0.6 > holderWidth) {
                const left = holderWidth - (pos + width * 0.6);
                holder.current.parentElement.style.position = 'relative';
                holder.current.parentElement.style.left = `${left}px`;
            }
        }
    }, [holder.current]);

    return (
        <div
            ref={holder}
            className={`chart-tooltip ${point.point ? 'line' : 'bar'}`}
            style={{
                position: 'relative',
                top: isTop ? 100 : 0,
            }}
        >
            <div className="flex flex-center">
                <span className="square mr5" style={{ backgroundColor: colour }}></span>
                <div>
                    {legendLabel && <div className="bold no-wrap">{legendLabel.label}</div>}
                    {legend && <div className="bold no-wrap">{legend}</div>}
                    <div>
                        <span className="mr5 bold no-wrap">{xFormat ? xFormat(xValue) : xValue}:</span>
                        <span className="mr5 no-wrap">{yFormat ? yFormat(yValue) : yValue}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomToolTip;
